<template>
  <el-table-column :label="label" :prop="prop" class-name="postal_code" :sortable="sortable" />
</template>

<script>
export default {
  components: {
  },
  props: {
    label: {
      type: String,
      default: '郵便番号'
    },
    prop: {
      type: String,
      default: 'postal_code'
    },
    sortable: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss">
.el-table {
  th,
  td {
    &.postal_code {
      width: 8em;
    }
  }
}
</style>
